import React from 'react';
import styles from './AvailabilityTimesBanner.scss';
import PropTypes from 'prop-types';
import { Text } from 'wix-style-react';

export const AvailabilityTimesBanner = props => {
  const { availability: parsedTimes, title } = props;
  return (
    <div className={styles.wrapper} data-hook="availability-times-banner">
      <Text className={styles.title} weight="normal" size="small">
        {title}
      </Text>
      <div className={styles.times}>
        {parsedTimes.map((period, index) => (
          <div className={styles.period} key={index}>
            <Text style={{ marginTop: '12px' }} size="small">
              {period.days}
            </Text>
            <Text size="small">{period.hours}</Text>
          </div>
        ))}
      </div>
    </div>
  );
};

AvailabilityTimesBanner.propTypes = {
  title: PropTypes.string,
  availability: PropTypes.arrayOf(
    PropTypes.shape({
      days: PropTypes.string,
      hours: PropTypes.string,
    }),
  ),
};
